import { Component, OnInit, ElementRef, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { gsap, Expo } from 'gsap';
import { UpdatesService } from '../../services/updates/updates.service';

@Component({
    selector: 'app-updates-page',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './updates-page.component.html', 
    styleUrls: ['./updates-page.component.scss']
}) 
export class UpdatesPageComponent implements OnInit {

    @ViewChild('btnClose', { static: true }) public btnClose: ElementRef | undefined;
    @ViewChild('messageElement', { static: true }) public messageElement: ElementRef | undefined;
    @ViewChild('emailaddress', { static: false }) public emailaddress: ElementRef | undefined;
    @ViewChild('container', { static: true }) public container: ElementRef | undefined;
    @ViewChild('content', { static: true }) public content: ElementRef | undefined;
    @ViewChild('successElement', { static: true }) public successElement: ElementRef | undefined;

    public email: string = '';
    public placeholder: string = 'Enter Email Address';

    message: string = '';

    updatesService = inject(UpdatesService);

    constructor() {
        this.updatesService.isUpdatesOpen$.subscribe((isOpen) => {
            isOpen ? this.animateIn() : this.animateOut();
        });
    }

    ngOnInit(): void {}

    animateIn() {
        gsap.to('app-updates-page', { duration: .7, display: 'block', autoAlpha: 1 });
        gsap.fromTo('app-updates-page .wrapper', { autoAlpha: 0, scale: .7 }, { duration: .7, autoAlpha: 1, scale: 1.3, delay: .1, ease: Expo.easeOut });
        gsap.fromTo('app-updates-page .header', { autoAlpha: 0, y: 30 }, { duration: .7, autoAlpha: 1, y: 0, delay: .3, ease: Expo.easeOut });
        gsap.fromTo('app-updates-page .closeButton', { scale: 0 }, { duration: .7, scale: 0.7694, delay: .4 });
    }

    animateOut() {
        gsap.to('app-updates-page', { duration: .7, display: 'none', autoAlpha: 0, delay: .1, overwrite: true });
        gsap.to('app-updates-page .wrapper', { duration: .5, scale: .85, autoAlpha: 0, overwrite: true, ease: Expo.easeOut });
    }

    onCloseOver() {
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImg'), { duration: .5, opacity: 1, ease: Expo.easeOut });
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImgOver'), { duration: .5, opacity: 1, ease: Expo.easeOut });
    }

    onCloseOut() {
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImg'), { duration: .5, opacity: 1, ease: Expo.easeOut });
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImgOver'), { duration: .5, opacity: 0, ease: Expo.easeOut });
    }

    onSubmitClick() {
        if (!this.email) {
            this.showMessage('Email address is blank');
        } else if (this.validateEmail(this.email)) {
            this.sendForm(this.email);
        } else {
            this.showMessage('Email address is invalid');
        }
    }

    sendForm(email: string) {
        this.placeholder = 'Sending...';
        this.email = '';
        this.updatesService.sendSubscribe(email).then((resp: string) => {
            this.email = '';
            this.placeholder = resp;
        });
    }

    onSuccess() {
        gsap.to(this.successElement?.nativeElement, { duration: .5, display: 'block', autoAlpha: 1, delay: .5 });
        gsap.to(this.content?.nativeElement, { duration: .5, display: 'none', autoAlpha: 0 });
    }

    onCloseClick() {
        this.animateOut();
        this.updatesService.closeUpdates()
    }

    validateEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }

    showMessage(text: string) {
        this.message = text;
        gsap.to(this.messageElement?.nativeElement, { duration: .5, display: 'block', color: 'white' });
    }
}
